
import {SuperTradeCatogeryConfig} from 'main/content/inventory/superTradeCategory/SuperTradeCategoryConfig';
import {TradeCatogeryConfig} from 'main/content/inventory/tradeCategory/TradeCategoryConfig';
import {DepartmentCatogeryConfig} from 'main/content/inventory/departmentCategory/DepartmentCategoryConfig';
import {SubCategoryConfig} from 'main/content/inventory/subCategory/SubCategoryConfig';
import {RackConfig} from 'main/content/inventory/rack/RackConfig';
import {BrandConfig} from 'main/content/inventory/brand/BrandConfig';
import {ManufactureConfig} from 'main/content/inventory/manufacture/ManufactureConfig';
import {ItemConfig} from 'main/content/inventory/item/ItemConfig';
import {RackLevelConfig} from 'main/content/inventory/rackLevel/RackLevelConfig';
import {RackPositionConfig} from 'main/content/inventory/rackPosition/RackPositionConfig';
import { SupplierConfig } from 'main/content/inventory/supplier/SupplierConfig';

export const InventoryConfig = [ 
    SuperTradeCatogeryConfig,
    TradeCatogeryConfig,
    DepartmentCatogeryConfig,
    SubCategoryConfig,
    RackConfig,
    BrandConfig,
    ManufactureConfig,
    ItemConfig,
    RackLevelConfig,
    RackPositionConfig,
    SupplierConfig
];





// WEBPACK FOOTER //
// ./src/main/content/inventory/inventoryRoutesConfig.js